import { repository } from "repositories";
import { GetTagListParams, GetTagListRes, SWRResponse } from "shared/types";
import useSWR from "swr";

export const useTagList = (
  params: GetTagListParams
): SWRResponse<GetTagListRes> => {
  const repo = repository.tag.getList(params);

  const { data, error, mutate } = useSWR(
    [repo.path, ...Object.values(params)],
    repo.data,
    { fallbackData: { tags: [] } }
  );

  return {
    tags: data?.tags,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};
